var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"s-app"},[(_vm.usuarioLogado)?_c('Header',{attrs:{"dadosUser":_vm.dadosUser}}):_vm._e(),(!_vm.validatingToken)?_c('Loader'):_c('Content',{attrs:{"usuarioLogado":_vm.usuarioLogado,"sessaoExpirada":_vm.sessaoExpirada,"dadosUser":_vm.dadosUser}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }